import { makeStyles, Theme, Typography } from "@material-ui/core";

interface Props {
  label: string;
  borderColor: string;
  value?: number;
  onClick?: () => void;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  clickable: ({ onClick }) =>
    onClick
      ? {
          cursor: "pointer",
          "&:hover": {
            color: theme.palette.info.main,
          },
        }
      : {},
}));

export const TotalVehiclesLegend = (props: Props) => {
  const { label, value, borderColor, onClick } = props;
  const classes = useStyles(props);
  return (
    <div
      className={classes.clickable}
      style={{ borderColor }}
      onClick={onClick}
    >
      <Typography variant="body2">{label}</Typography>
      <Typography variant="body1">{value ?? "-"}</Typography>
    </div>
  );
};
